export default "__VITE_ASSET__2d45e712__"